import React, { useEffect, useState } from "react";
import "./Home.css";
//import { useActionData } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import { Form, FormGroup, Input, Label, Table } from "reactstrap";

export function Nav() {
  return <>main league rations of the games</>;
}

//league_alq1 function
export function Algorithim_1({ selectedLeague }) {
  const [data, setData] = useState([]);
  const API_URL = process.env.REACT_APP_DIRECT || "http://192.168.1.103:8081";
  useEffect(() => {
    console.log("jina");
    console.log(selectedLeague);
    fetch(`${API_URL}/table/${selectedLeague}`)
      .then((res) => res.json())
      .then((data) => setData(data))
      .catch((err) => console.log(err));
  }, [selectedLeague]);
  return (
    <>
      <div className="alg1_card">
        <Table striped>
          <thead>
            <tr>
              <th> Pos</th>
              <th> Team_Name </th>
              <th> MP </th>
              <th>GD</th>
              <th>Points</th>
              <th>More</th>
            </tr>
          </thead>
          <tbody>
            {data.map((d, i) => (
              <tr key={i}>
                <th scope="row">{d.Pos}</th>
                <td className="teamName">{d.Team}</td>
                <td>{d.MP}</td>
                <td>{d.GD}</td>
                <td>{d.PTS}</td>
                <td className="linktag">
                  {" "}
                  <a
                    href={`/Prediction?Team=${d.Team}&leagueselected=${selectedLeague} `}
                  >
                    More
                  </a>{" "}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </>
  );
}

//Corners function
